import { render, staticRenderFns } from "./WarrantyProducts.vue?vue&type=template&id=a3a532c2&"
import script from "./WarrantyProducts.vue?vue&type=script&lang=js&"
export * from "./WarrantyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports